import ChatsPage from './ChatsPage';


/**
 * The Example page config.
 */
const TrackingPageConfig = {
	settings: {
		layout: {
        }
	},
	routes: [
		{
			path: '/',
			element: <ChatsPage />
		},
		{
			path: '/:id',
			element: <ChatsPage />
		}
	]
};

export default TrackingPageConfig;
